import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  styled,
  Switch,
  Typography,
  useTheme,
} from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import CustomSelect from '../../../../components/form/CustomSelect';
import CustomInput from '../../../../components/form/CustomInput';
import { Rules } from '../../../../helpers/RHFRules';
import NumberFormatCustom from '../../../../components/form/NumberFormatCustom';
import { isAfterEndDate } from '../../../../helpers/generalUtils';

const getMulishText = (fontWeight, color, fontSize) => ({
  fontFamily: 'Mulish, sans-serif',
  fontSize,
  fontWeight,
  color,
});
const CustomDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    width: '500px',
    maxWidth: '500px',
    minHeight: '430px',
    borderRadius: '10px',
  },
  '& .MuiDialogContent-root': {
    padding: theme.spacing(4),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(4),
  },
  minWidth: 500,
}));
const CustomTitle = styled(Typography)(({ theme }) => ({
  ...getMulishText(700, theme.backOffice.contracts.titleForm.color, 24),
}));
const EditFirmayaServiceModify = (props) => {
  const theme = useTheme();

  const {
    openClose,
    products,
    styles,
    modifyProduct,
    formData,
  } = props;
  const [isSwitchEnabled, setIsSwitchEnabled] = useState(false);

  const {
    handleSubmit,
    errors,
    control,
    setValue,
    getValues,
  } = useForm({
    mode: 'onChange',
  });

  const listValidityTypeContracts = products?.listValidityTypeContracts;
  const transformedListMaxValidityAmountContracts = products?.transformedListMaxValidityAmountContracts;
  const setIsDialogOpen = openClose?.close;
  const currentIndex = modifyProduct?.currentIndex;
  const setServicesToAdd = modifyProduct?.setServicesToAdd;
  const setAlertInfo = openClose?.setAlertInfo;
  const setIsAlertOpen = openClose?.setIsAlertOpen;
  const alertStyles = styles?.alertStyles;
  const ownWarningIcon = styles?.OwnWarningIcon;
  const messageStyle = styles?.messageStyle;

  useEffect(() => {
    if (openClose?.isOpen) {
      if (products?.currentProduct?.isSwitchEnabled) setValue('quantityToAddService', '');
      setIsSwitchEnabled(products?.currentProduct?.isSwitchEnabled);
      setValue('quantityToAddService', '');
      setValue('isSwitchEnabled', products?.currentProduct?.isSwitchEnabled);
    }
  }, [openClose, products, setValue]);

  const setValidityType = (event) => {
    const { value } = event.target;
    if (event.target.name === 'validityService') {
      setValue('validityService', value);
      setValue('validityAmount', '');
    }
    return value;
  };

  const handleSwitchChangeProduct = (event) => {
    setValue('quantityToAddService', '');
    setValue('isSwitchEnabled', event.target.checked);
    setIsSwitchEnabled(event.target.checked);
  };

  const editProduct = (data) => {
    if (isAfterEndDate(getValues('validityService'), getValues('validityAmount'), formData?.startDate, formData?.endDate)) {
      setAlertInfo({
        tituloModal: 'Vigencia de la bolsa',
        textButtonAcept: 'Aceptar',
        handleAccept: () => setIsAlertOpen(false),
        messageAlert: messageStyle(theme, ownWarningIcon, 40, '508px', '200px'),
        showClose: false,
        isOnlyMessage: false,
        mensajeModal: 'Ten en cuenta que la vigencia de la bolsa debe ser menor o igual a la fecha de finalización del contrato.',
      });
      setIsAlertOpen(true);
      return;
    }
    setServicesToAdd((prevServices) => prevServices.map(
      (service, index) => (index === currentIndex ? { ...service, ...data, isUpdate: true } : service),
    ));
    setIsDialogOpen(false);
    setAlertInfo({
      tituloModal: '¡Servicio actualizado!',
      showClose: false,
      isOnlyMessage: true,
      messageAlert: alertStyles(theme, styles?.OwnSuccesfullIcon, '508px', '284px', 65),
    });
    setIsAlertOpen(true);
    setTimeout(() => {
      setIsAlertOpen(false);
    }, 2000);
  };

  return (
    <CustomDialog open={openClose?.isOpen}>
      <DialogTitle
        style={{
          marginBottom: -20,
          marginTop: 30,
          marginLeft: 14,
        }}
        id="customized-dialog-title"
      >
        <CustomTitle>Editar servicio</CustomTitle>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <CustomSelect
              label="Servicios"
              name="productService"
              defaultValue={products?.currentProduct?.productService}
              options={products?.listProducts}
              control={control}
              error={errors}
              styleFromHelperText={{ style: { marginRight: 10 } }}
              classes={styles.typeInput}
              disabled
            />
          </Grid>
          <Grid item xs={6}>
            <FormControlLabel
              control={(
                <Controller
                  name="isSwitchEnabled"
                  control={control}
                  defaultValue={products?.currentProduct?.isSwitchEnabled}
                  render={() => (
                    <Switch
                      checked={isSwitchEnabled}
                      onChange={handleSwitchChangeProduct}
                      color="primary"
                    />
                  )}
                />
            )}
              label={(
                <Typography noWrap style={getMulishText(500, '#575756', 14)}>
                  Cantidad ilimitada
                </Typography>
            )}
            />
          </Grid>
          <Grid item xs={6}>
            <NumberFormatCustom
              label="Cantidad"
              name="quantityToAddService"
              defaultValue={products?.currentProduct?.isSwitchEnabled ? '' : products?.currentProduct?.quantityToAddService}
              required={!isSwitchEnabled}
              control={control}
              error={isSwitchEnabled ? [] : errors}
              rule={isSwitchEnabled ? [] : Rules.positiveValue}
              styleFromHelperText={{ style: { marginRight: 10 } }}
              classes={styles.typeInput}
              inputProps={{
                maxLength: 10,
              }}
              disabled={isSwitchEnabled}
            />
          </Grid>
          <Grid item xs={12}>
            <CustomSelect
              label="Tipo vigencia"
              name="validityService"
              options={listValidityTypeContracts}
              control={control}
              required
              rule={Rules.required}
              error={errors}
              styleFromHelperText={{ style: { marginRight: 10 } }}
              inputProps={{ onChange: (e) => setValidityType(e) }}
              classes={styles?.typeInput}
              defaultValue={products?.currentProduct?.validityService}
            />
          </Grid>
          <Grid item xs={12}>
            <CustomInput
              label="Vigencia"
              name="validityAmount"
              control={control}
              error={errors}
              required
              defaultValue={products?.currentProduct?.validityAmount}
              rule={Rules.numerico}
              styleFromHelperText={{ style: { marginRight: 10 } }}
              inputProps={{
                maxLength: 5,
              }}
              onValidate={(e) => {
                if (e.target.value <= 0) {
                  setValue('validityAmount', '');
                }
                const valueTypeValidity = getValues('validityService');
                if (transformedListMaxValidityAmountContracts.length > 0) {
                  const valueMax = transformedListMaxValidityAmountContracts.find(
                    (maxValidity) => maxValidity.value === valueTypeValidity,
                  )?.amount;
                  if (e.target.value > valueMax) {
                    setValue('validityAmount', '');
                  }
                }
              }}
              classes={styles?.typeInput}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2} style={{ paddingTop: 20 }}>
          <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center', gap: '16px' }}>
            <Button
              type="button"
              variant="contained"
              color="primary"
              size="medium"
              className={styles.cancelButton}
              onClick={() => {
                setIsDialogOpen(false);
              }}
            >
              Cancelar
            </Button>
            <Button
              type="button"
              variant="contained"
              color="primary"
              size="medium"
              className={styles.buttonStyles}
              onClick={handleSubmit(editProduct)}
            >
              Actualizar servicio
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </CustomDialog>
  );
};

export default EditFirmayaServiceModify;
